import {GetBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/banner/service.types';

const HERO_IMAGE =
  'https://cdn.aboutstatic.com/file/8b52d4f5eccc56d4b0e211d0f04531e0.jpg?quality=75&height=430&width=860';

const PRODUCT_IMAGE_URLS = [
  'https://cdn.aboutstatic.com/file/4572f144890ab45c9000f8a4dedaa215.png?quality=75',
  'https://cdn.aboutstatic.com/file/91ff73682773ed3e0a5736fbb0e7e9e8?width=200&quality=75',
  'https://cdn.aboutstatic.com/file/5bd722080ccfa4531d1796b17a28bc9e?width=200&quality=75',
];

export const categoryBannerMock: GetBannerResponse = {
  banner: {
    variant: {
      $case: 'sponsoredBrand',
      sponsoredBrand: {
        media: {
          backgroundColor: '#1F2937',
          variant: {
            $case: 'image',
            image: {
              url: HERO_IMAGE,
              description: 'Sponsored brand hero',
              external: false,
            },
          },
        },
        colors: {
          foregroundColor: {hex: '#FFFFFF'},
          backgroundColor: {hex: '#111827'},
        },
        brand: {
          id: 4711,
          name: 'Sample Brand',
          path: '/brands/sample-brand',
          slug: 'sample-brand',
          deprecatedSquareImage: {url: '', description: '', external: false},
          deprecatedPortraitImage: {url: '', description: '', external: false},
          deprecatedLandscapeImage: {url: '', description: '', external: false},
        },
        productImages: PRODUCT_IMAGE_URLS.map((src, i) => ({
          src,
          description: `Product ${i + 1}`,
          isEnclosed: false,
        })),
        header: {
          $case: 'sponsored',
          sponsored: {
            infoIcon: {
              label: 'sponsored',
              variant: {
                $case: 'displayText',
                displayText: {
                  headline: 'Why am I seeing this?',
                  subline: {
                    text: 'This banner is part of a paid partnership with Sample Brand.',
                  },
                },
              },
            },
          },
        },
        target: {url: '/brands/sample-brand', external: false},
        tracker: {
          $case: 'promotionTracker',
          promotionTracker: {
            promotionId: 'mock-category-banner',
            promotionName: 'Mock Category Banner',
            creativeName: 'sponsoredBrand',
            creativeSlot: 'category-header',
          },
        },
      },
    },
  },
};
